import { render, staticRenderFns } from "./update-extend-package.vue?vue&type=template&id=08017e2c&scoped=true"
import script from "./update-extend-package.vue?vue&type=script&lang=js"
export * from "./update-extend-package.vue?vue&type=script&lang=js"
import style0 from "./update-extend-package.vue?vue&type=style&index=0&id=08017e2c&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08017e2c",
  null
  
)

export default component.exports